import React from 'react';

import EventListingStatus from './EventListingStatus';

const EventsList = props => {
    const {events} = props;

    return (
        <ul>
            {events.map(event => (
                <li key={event.id}>
                    <EventListingStatus event={event} {...props} />
                </li>
            ))}
        </ul>
    );
};

export default EventsList;
